<template>
  <div>
    <button class="speech-audio" @click="onSpeech">
      <feather-icon
        v-if="isPlaying && showVolume"
        icon="PauseIcon"
        class="cursor-pointer icon-down"
        @click.stop="onPause()"
      ></feather-icon>
      <feather-icon
        v-if="!isPlaying && showVolume"
        icon="PlayIcon"
        class="cursor-pointer icon-down"
        @click.stop="onSpeech"
      ></feather-icon>
      <span
        v-if="showVolume"
        class="text-spech-text"
        :class="{ 'playing off': isPlaying }"
        >{{ $t("REPORT").Hear_Text }}</span
      >
      <span
        v-if="showVolume"
        class="text-spech-text"
        :class="{ 'playing off': !isPlaying }"
        >{{ $t("REPORT").Hear_Text_Hearing }} {{ title }}</span
      >
    </button>
    <button
      class="speech-rate"
      @click.stop="changeRateSpeech"
      v-if="!isPlaying"
    >
      <span>{{ rateTextSpeechLabel }}</span>
    </button>
  </div>
</template>

<script>
import { CONTENT } from '../../../enums/enum-content';
import translateFieldHelper from '../../../helpers/translate-field-helper';
import FormatFieldHelper from '../../../helpers/format-field-helper';
import TextToSpeech from "../../../plugins/TextToSpeech";

export default {
  props: {
    detail: {
      type: Object,
      require: true,
    },
  },
  computed: {
    title() {
        if (!this.detail) return "";
        if (
            this.detail.newsContent[0].code == CONTENT.STATISTIC ||
            this.detail.newsContent[0].code == CONTENT.EXPORTS ||
            this.detail.newsContent[0].code == CONTENT.INFORMATIVE
        ) {
            return translateFieldHelper.getTranslateField(
            "name",
            this.detail.reportType
            );
        }
        return this.detail.content.title.data;
    },
    getTextToSpeech() {
      if (
        this.detail.content.title ||
        this.detail.content.abstract ||
        this.detail.content.text
      ) {
        return FormatFieldHelper.removeDuplicateItem([
          this.detail.content.title.data,
          this.detail.content.abstract.data,
          this.detail.content.text.data
        ]);
      }
      return false;
    },
    isPlaying() {
      return this.$store.state.textSpeechIsPlaying;
    },
    showVolume() {
      return this.getTextToSpeech;
    },
    rateTextSpeech() {
      return this.$store.state.AppActiveUser.rateTextSpeech;
    },
    rateTextSpeechLabel() {
      switch (this.rateTextSpeech) {
        case 1.0:
          return "1x";
        case 1.5:
          return "1.5x";
        case 2.0:
          return "2x";
        default:
          return "1x";
      }
    },
  },
  methods: {
    onSpeech() {
      TextToSpeech.onSpeech(this.detail);
    },
    onPause() {
      TextToSpeech.onPause();
    },
    changeRateSpeech() {
      TextToSpeech.changeRateSpeech();
    },
    cancelSpeech() {
      try {
        TextToSpeech.onPause();
        TextToSpeech.onCancel();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>
</style>